export default __webpack_public_path__ + "static/map-081537fea5ec3ec5b6032aecbed686ac.png";